import { render, staticRenderFns } from "./navbar-payment.vue?vue&type=template&id=4a0540f8&scoped=true&"
import script from "./navbar-payment.vue?vue&type=script&lang=ts&"
export * from "./navbar-payment.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-payment.vue?vue&type=style&index=0&id=4a0540f8&lang=scss&scoped=true&"
import style1 from "./navbar-payment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0540f8",
  null
  
)

export default component.exports